import $ from 'jquery';
var isHidden = true;
var element = $("#mobile-menu");
var width = element.outerWidth();
var windowWidth = $(window).outerWidth();
var left = windowWidth - width;
var shadowWidth = 0;

$(window).resize(function () {
    width = element.outerWidth();
    windowWidth = $(window).outerWidth();
    left = windowWidth - width;
    $('.nav-icon.is-active').trigger('click');
});

$('button.hamburger').click(function () {

    $('button.hamburger').toggleClass('is-active');

    if ($('button.hamburger').hasClass('is-active')) {
        $('body').addClass('fancybox-active compensate-for-scrollbar');
    } else {
        $('body').removeClass('fancybox-active compensate-for-scrollbar');
    }

    if (isHidden) {
        $('#drawer').removeClass('show');
        element.stop().animate({
            left: left + 'px'
        });
        $('.menu-fixed').removeClass('active');
        $(".page-wrapper").stop().animate({
            'right': width + shadowWidth + 'px'
        });
    } else {
        var offset = 200;
        element.stop().animate({
            'left': '100%'
        });
        if (window.pageYOffset >= offset) {
            $('.menu-fixed').addClass('active');
        }
        $(".page-wrapper").stop().animate({
            'right': '0px'
        })
    }
    isHidden = !isHidden;
});